import { ApexOptions } from "apexcharts";
import { useContext, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useParams } from "react-router-dom";
import { Documents } from ".";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
interface Collects {
  status: string;
  qtd: number;
}
export const ChartBar = ({ data }: Documents) => {
  const {
    getSizesComponent,
    setFontSize,
    componentProperty,
    generateRedirectUrl,
  } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const labelsOrder = [
    "Não iniciada",
    "Em trânsito",
    "Chegou",
    "Finalizada",
  ];
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  const [options, setOptions] = useState<ApexOptions | null>(null);
  const [series, setSeries] = useState<{ data: number[] }[] | null>(null);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-general-collects-documents" });
    if (sizes.width < 345) {
      setFontSize({
        id: "chart-general-collects-documents",
        width: sizes.width,
      });
    }
    setWidthChart(sizes.width);
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-general-collects-documents`)
          ?.parentNode as HTMLElement
      ).style.width.slice(0, -2)
    ),
    data.collects,
  ]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-general-collects-documents" });

    setHeightChart(sizes.height - 40);
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-general-collects-documents`)
          ?.parentNode as HTMLElement
      ).style.height.slice(0, -2)
    ),
    data.collects,
  ]);
  

  useEffect(() => {
    const clStatus: string[] = [],
      cldataChart: number[] = [];
    const sizes = getSizesComponent({ id: "chart-general-collects-documents" });

    labelsOrder.map((status) => {
      const obj = data.collects.find((o: Collects) => o.status === status);
      if (obj) {
        clStatus.push(obj.status);
        cldataChart.push(obj.qtd);
      } else {
        clStatus.push(status);
        cldataChart.push(0);
      }
    });
    if (cldataChart && cldataChart.length !== 0) {
      const fakesCol = Math.floor(sizes.height / cldataChart.length / 230);
      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          cldataChart.push(0);
        }
      }
    }
    loadDataChart(cldataChart, clStatus);
  }, [data]);

  const loadDataChart = async (cldataChart: number[], clStatus: string[]) => {
    const sizes = getSizesComponent({ id: "chart-general-collects-documents" });
    if (cldataChart && cldataChart.length !== 0) {
      setTotal(
        cldataChart.reduce(function (soma: number, i: number) {
          return +soma + +i;
        })
      );
    }
    if (sizes.width < 345) {
      setFontSize({
        id: "chart-general-collects-documents",
        width: sizes.width,
      });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setSeries([
      {
        data: cldataChart,
      },
    ]);
    loadOptions(cldataChart, clStatus);
  };

  async function loadOptions(dataChart: number[], labels: string[]) {
    setOptions({
      chart: {
        animations: {
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
          enabled: false,
        },
        type: "bar",
        toolbar: {
          show: false,
        },
        events: {
          dataPointSelection: async (event, chartContext, config) => {
            let status = "";
            switch (labels[config.dataPointIndex]) {
              case "Não iniciada":
                status = "0,7,12,15,20";
                break;
              case "Em trânsito":
                status = "1,5,18";
                break;
              case "Chegou":
                status = "2,10,11";
                break;
              case "Finalizada":
                status = "3,4,6,8,9,17";
                break;
            }
            if (
              mode === "view" &&
              componentProperty({
                id: "chartGeneralCollectsDocuments",
                property: "redirect",
              })
            ) {
              window.open(
                await generateRedirectUrl("chartGeneralCollectsDocuments", {
                  redirectTowerToIndex: true,
                  date: true,
                  dueRouteDate: true,
                  route_stop_type: 'C',
                  status_stop_id: status
                }),
                "_blank"
              );
            }
          },
        },
      },
      plotOptions: {
        bar: {
          barHeight: "80%",
          distributed: true,
          horizontal: true,
          dataLabels: { position: "bottom" },
        },
      },
      colors: ["#B1BCBE", "#FFF49C", "#8FD3FF", "#85DE77"],
      dataLabels: {
        enabled: true,
        textAnchor: "start",
        formatter: function (val, opt) {
          if (labels[opt.dataPointIndex]) {
            return labels[opt.dataPointIndex] + ":  " + val;
          }
          return "";
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: { position: "bottom" },
          },
        },
      ],
      yaxis: {
        labels: {
          show: false,
        },
      },
      xaxis: {
        max: Math.max(...dataChart),
        range: 7,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      labels: labels,
      tooltip: { enabled: false },
      legend: { show: false },
    });
    setCompleteRequisition(true);
  }

  return completeRequisition && series && options ? (
    <div className="h100 w100">
      <HeaderComponent
        title={`Andamento geral: Você tem ${total} coletas hoje`}
        clickable={componentProperty({
          id: "chartGeneralCollectsDocuments",
          property: "redirect",
        })}
        id="chart-general-collects-documents"
        width={widthChart}
      />
      <div id={"fixedBox"}>
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics />
  );
};
